import React from 'react';

// Import Icons from assets/img/servicechoose
import icon1 from '../../assets/img/servicechoose/1.png';
import icon2 from '../../assets/img/servicechoose/2.png';
import icon3 from '../../assets/img/servicechoose/3.png';
import icon4 from '../../assets/img/servicechoose/4.png';
import icon5 from '../../assets/img/servicechoose/5.png';
import icon6 from '../../assets/img/servicechoose/6.png';
import icon7 from '../../assets/img/servicechoose/7.png';
import icon8 from '../../assets/img/servicechoose/8.png';

const ServiceChoose = ({ title, subtitle, points: customPoints }) => {
  const defaultItems = [
    {
      icon: <img src={icon1.src || icon1} alt="Expertise" className="choose-custom-img" />,
      title: "Expertise",
      desc: "Scan to BIM services are a result of products through well-experienced professional experts capable of the latest BIM techniques and software."
    },
    {
      icon: <img src={icon2.src || icon2} alt="Reliable Solution" className="choose-custom-img" />,
      title: "Reliable Solution",
      desc: "Providing correct Scan to BIM solutions, the Chudasama Outsourcing team guarantees a level of inconsistency & validity throughout the entire project lifecycle."
    },
    {
      icon: <img src={icon3.src || icon3} alt="Focus on Core Competencies" className="choose-custom-img" />,
      title: "Focus on Core Competencies",
      desc: "Leave the project complexity of the BIM conversion to the experts while you attend to your core competencies by outsourcing your Scan to BIM to Chudasama Outsourcing."
    },
    {
      icon: <img src={icon4.src || icon4} alt="Latest Technology" className="choose-custom-img" />,
      title: "Latest Technology",
      desc: "Chudasama Outsourcing employs advanced technology for Scan to BIM conversion to increase the level of clarity and performance of each undertaking."
    },
    {
      icon: <img src={icon5.src || icon5} alt="Scalability" className="choose-custom-img" />,
      title: "Scalability",
      desc: "Chudasama Outsourcing high-end solutions adapt seamlessly from small to large scale for any Scan to BIM project."
    },
    {
      icon: <img src={icon6.src || icon6} alt="Collaboration" className="choose-custom-img" />,
      title: "Collaboration",
      desc: "The Chudasama Outsourcing team will provide an endless connection to all other stakeholders that participate in the project for productive success."
    },
    {
      icon: <img src={icon7.src || icon7} alt="Faster Turnaround" className="choose-custom-img" />,
      title: "Faster Turnaround",
      desc: "Our turnaround time for Scan to BIM projects is faster with the help of advanced tools and workflows that help in meeting deadlines."
    },
    {
      icon: <img src={icon8.src || icon8} alt="Global Reach" className="choose-custom-img" />,
      title: "Global Reach",
      desc: "Chudasama Outsourcing has a global forum by serving customers across every corner of the world. The firm offers the Scan to BIM services with an eye to the international standards and requirements."
    }
  ];

  const defaultIcons = [icon1, icon2, icon3, icon4, icon5, icon6, icon7, icon8];
  
  const displayPoints = customPoints ? customPoints.map((p, index) => ({
    ...p,
    icon: p.icon || <img src={defaultIcons[index].src || defaultIcons[index]} alt={p.title} className="choose-custom-img" />
  })) : defaultItems;

  return (
    <section className="service-choose-section">
      <div className="service-choose-container">
        <div className="service-choose-header">
          <h2 className="service-choose-title">
            {title || (
              <>
                <span className="text-primary">Why Choose As-Built Modeling</span> Services for Your Next Project?
              </>
            )}
          </h2>
          <p className="service-choose-subtitle">
            {subtitle || "Unlock next-level accuracy and project control with our expertly crafted As-Built BIM Modeling Services, guaranteed to reduce risk, save time, and enhance every stage of your asset's lifecycle."}
          </p>
        </div>

        <div className="service-choose-grid">
          {displayPoints.map((point, index) => (
            <div key={index} className="choose-card">
              <div className="choose-icon-box">
                {point.icon}
              </div>
              <h3>{point.title}</h3>
              <p>{point.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceChoose;
